
export default class JargonBuster {
  constructor(element, optionalContainer = document) {
    this.passedElement = element;
    this.container = optionalContainer;
    this.cardLinks = [];
    this.init();
  }

  init = () => {
    if (!this.initialised) {
      this.initialised = true;
      this.getElements();
      this.addEventListeners();
      let initialTarget = this.getTargetId(document.URL);

      if(initialTarget){
        this.scrollToId(initialTarget);
        setTimeout(() => {
          this.openCard(this.container.querySelector(`#${initialTarget}`));
        }, 500);
      }
      this.getAllCardLinks();
      this.addEventToCardLinks();
    }
  }


  getTargetId = (string) => {
    var url = string;
    let hasID = url.includes('#');
    return (hasID) ? url.substring(url.lastIndexOf('#') + 1) : false;
  }


  scrollToId = (id) => {
    let element = this.container.querySelector(`#${id}`);
    // console.log(element);
    //
    // let coords = element.getBoundingClientRect();
    //
    // console.log(coords);
    //
    // let currentScroll = document.documentElement.scrollTop || document.body.scrollTop;

    setTimeout(() => {
      // window.scrollTo({
      //   top: currentScroll + coords.top,
      //   behavior: 'smooth'
      // });
      //
      element.scrollIntoView({behavior: "smooth", block: "center", inline: "nearest"});
    }, 250)
  }

  getAllCardLinks = () => {
    let links = this.container.querySelectorAll('.flashcard__content a');
    links.forEach((item, i) => {
      let href = item.getAttribute('href');
      if (href.includes('#')) {
        this.cardLinks.push(item);
      } else {
      }
    });
  }

  handleLinkClick = (e) => {
    e.preventDefault();
    let targetId = this.getTargetId(e.target.getAttribute('href'));
    if(targetId){
      this.showAllResults();
      this.scrollToId(targetId);
      setTimeout(() => {
        this.openCard(this.container.querySelector(`#${targetId}`));
      }, 500);
    } else {
      console.error("can't find id in ", targetId);
    }
  }

  addEventToCardLinks = () => {
    this.cardLinks.forEach((item, i) => {
      item.addEventListener('click', this.handleLinkClick);
    });
  }

  handleSearchChange = (e) => {
    if (e.target.value) {
      let resultCount = 0;

      this.catHeadings.forEach((item, i) => {
        item.style.display = "none";
      });

      this.flashcards.forEach((item, i) => {
        let title = item.querySelector('.flashcard__title').innerHTML;
        if(title.toLowerCase().includes(e.target.value.toLowerCase())){
          let col = item.closest('.js-flashcard').style.display = "block";
          resultCount++;
        } else {
          let col = item.closest('.js-flashcard').style.display = "none";
        }
      });
      if (resultCount === 0) {
        this.noResults.style.display = "block";
      } else {
        this.noResults.style.display = "none";
      }

      this.levelsNav.style.display = "none";
    } else {
      this.levelsNav.style.display = "block";

      this.catHeadings.forEach((item, i) => {
        item.style.display = "block";
      });
      this.flashcards.forEach((item, i) => {
        let col = item.closest('.js-flashcard').style.display = "block";
      });
      this.noResults.style.display = "none";
    }
  }

  showAllResults = () => {
    this.search.value = "";
    this.flashcards.forEach((item, i) => {
      item.closest('.js-flashcard').style.display = "block";
    });
    this.catHeadings.forEach((item, i) => {
      item.style.display = "block";
    });
    this.noResults.style.display = "none";
  }


  getElements = () => {
    this.flashcards = this.container.querySelectorAll('.js-flashcard');
    this.catHeadings = this.container.querySelectorAll('.js-cat-headings');
    this.levelsNav = this.container.querySelector('.js-levels-nav');
    this.search = this.container.querySelector('#jargonSearch');
    this.noResults = this.container.querySelector('#jargonNoResults');
  }

  openCard = (item) => { item.classList.add('open'); }
  closeCard = (item) => { item.classList.remove('open'); }

  addEventListeners = () => {
    this.flashcards.forEach((item, i) => {
      item.addEventListener('click', this.flipCard);
    });

    this.search.addEventListener('input', this.handleSearchChange);
  }

  flipCard = (e) => {
    let flashcard = e.target.closest('.flashcard');
    if(flashcard.classList.contains('open')){
      this.closeCard(flashcard);
      return;
    } else {
      this.openCard(flashcard);
    }
  }

  removeEventListeners = () => {}

  dismantle = () => {
    this.removeEventListeners();
    this.passedElement = null;
    this.initialised = false;
  }

}
